import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';
import Name from '../Name/Name';

const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressForm';

// returns a Redux Form validation function
export const isValidFirstName = (msg, griffinNameHandler) => (value) => {
    const name = {
        givenName: value,
        surname: ''
    };
    if (griffinNameHandler.validateName(name, {field: 'givenName'}).errors) {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export class FirstName extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        validations: PropTypes.arrayOf(PropTypes.func)
    };
    
    render() {
        const { intl, validations = [] } = this.props;

        return (
            <Name
                id="firstName"
                name="firstName"
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.firstname-label`})}
                validations={validations}
            />
        );
    }
}

export default injectIntl(FirstName);
